import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-71" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-72" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black text-plum" data-id="element-73" data-mp="32p5kybpb6omo">
          CORÉEN EXPRESS<span className="align-super text-xs" data-id="element-74" data-mp="36oo5h6d7wxoz">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-75" data-mp="3uf0n58y9m8sr">
          La méthode visuelle pour apprendre le coréen depuis zéro : Hangeul, prononciation, phrases
          réelles et expressions de K-Drama / K-Pop en 60 minutes. Parce qu'aimer la culture
          coréenne ne devrait pas signifier dépendre des sous-titres pour toujours.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-76" data-mp="3qfjj8jyhljpp">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="2a1jjb8zn5u2g">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3lbmvrwv0jgi0" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-79" data-mp="3gck1n7gkmuot">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-80" data-mp="3q8wrtvcwqqet" /> @sigmasmart.french
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-81" data-mp="82qplkz0zfq1">
          🌸 « 안녕하세요 — Votre premier mot coréen commence aujourd'hui. »
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-82" data-mp="31umvaqetzm7">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="huwlh5seehai">
            Conditions d'utilisation
          </a>
          <span data-id="element-84" data-mp="qsqdw5n1kqse">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="qub97xh6kdrb">
            Politique de confidentialité
          </a>
          <span data-id="element-86" data-mp="tv4ng298r450">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-87" data-mp="tvmodc6um6j9">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-88" data-mp="yupnyh427kju">
          © 2026 CORÉEN EXPRESS™ — SIGMA SMART™ — Tous droits réservés. Reproduction et
          redistribution interdites sans autorisation expresse.
        </p>
      </div>
    </footer>;
}